// extracted by mini-css-extract-plugin
module.exports = {"container":"tagSection_container__mxN1B","tagLayout":"tagSection_tagLayout__U_2pQ"};